<template>
  <transition name="move-bottom" @after-leave="afterLeave">
    <div v-show="showFooterAd" class="sticky-ad fixed bottom-0 right-0 left-0 z-10 bg-white u-center">
      <transition name="collapse">
        <div v-show="showFooterAd" class="collapse" style="width: 320px">
          <div id="div-gpt-ad-sticky"></div>
        </div>
      </transition>
      <!-- <div class="sticky-inner-area flex-grow u-center"> -->
      <OButton pure @click="closeAd">
        <OIcon icon="chevron-left" svg-class="bg-[#d9d9d9] h-5 w-5 p-1 text-primary-300 u-center rounded -rotate-90" />
      </OButton>
      <!-- </div> -->
    </div>
  </transition>
</template>
<script>
import { defineComponent, ref, onMounted, inject, computed, onBeforeUnmount } from '@nuxtjs/composition-api';
import { adConfig } from '@/modules/ads/constants/units/ads';
import { useWindowSize } from '@vueuse/core';
import { createGPTSlot, callPrebid, createPrebidAdUnit } from '~/modules/ads/utils/utils';
import { LANG } from '~/constants/config';
import { activeTabInterval } from '~/modules/common/utils/helpers';
import { OButton, OIcon } from '~/modules/common/components/ui';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';
export default defineComponent({
  components: { OButton, OIcon },
  setup() {
    const slot = ref(null);
    const refreshTimer = ref(null);
    const showFooterAd = ref(false);
    const adUnit = adConfig.areas.mobile.stickyFooter;
    const adMode = inject('adConfig');
    const adWidth = ref(0);
    let isAdRendered = false;
    let currentScrollY = 0;
    const { sendAdEvent } = onedioEvents();
    // const { $analyticsEvent } = useContext();
    const { width } = useWindowSize();

    const buttonDivWidth = computed(() => width.value - adWidth.value - 7);

    const afterLeave = () => {
      window.googletag.cmd.push(() => {
        window.googletag.destroySlots([slot.value]);
      });
    };

    const closeAd = (e) => {
      // Chrome Freeze Hit Test Fix
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      sendAdEvent('Sticky Ad', 'close_click', 'Footer');
      refreshTimer.value?.clear();
      refreshTimer.value = null;
      showFooterAd.value = false;
      window.googletag.pubads().removeEventListener('slotRenderEnded', stickyFooterRenderEvent);
    };

    const createSlot = () => {
      window.googletag = window.googletag || { cmd: [] };
      const googletag = window.googletag;
      googletag.cmd.push(function () {
        slot.value = createGPTSlot(adUnit, adUnit.divId, adMode.value.targetings);
        if (LANG === 'tr') {
          callPrebid(slot.value);
        } else {
          googletag.pubads().refresh([slot.value]);
        }
        googletag.pubads().addEventListener('slotRenderEnded', stickyFooterRenderEvent);
      });
    };

    const setIdleTime = () => {
      let idleTimeout = setTimeout(() => {
        createSlot();
        isAdRendered = true;
        clearTimeout(idleTimeout);
        idleTimeout = null;
      }, 15 * 1000);
    };

    const handleScroll = () => {
      if (window.scrollY > currentScrollY + 150) {
        !isAdRendered && createSlot();
        window.removeEventListener('scroll', handleScroll);
      }
    };

    function stickyFooterRenderEvent(event) {
      const slotEvent = event.slot;
      if (slotEvent === slot.value) {
        if (!event.isEmpty) {
          adWidth.value = (event.size[0] <= 1 ? 320 : event.size[0]) || 320;
          if (!showFooterAd.value) {
            showFooterAd.value = true;
            if (LANG === 'tr') {
              refreshTimer.value = activeTabInterval(() => callPrebid(slot.value), adUnit.refreshTimer * 1000);
            } else {
              refreshTimer.value = activeTabInterval(() => {
                window.googletag.pubads().refresh([slot.value]);
              }, adUnit.refreshTimer * 1000);
            }
          }
        } else if (event.isEmpty) {
          closeAd();
        }
      }
    }

    onMounted(() => {
      currentScrollY = window.scrollY;
      setIdleTime();
      if (LANG === 'tr') {
        window.pbjs.que.push(function () {
          window.pbjs.addAdUnits([createPrebidAdUnit(adUnit)]);
        });
      }

      // Check membrana video ads sticky on footer
      window.addEventListener('load', () => {
        window.yieldMaster?.addEventListener('VIDEO_AD_STICK', function () {
          refreshTimer.value.clear();
        });
        window.yieldMaster?.addEventListener('VIDEO_AD_UNSTICK', function () {
          if (LANG === 'tr') {
            refreshTimer.value = activeTabInterval(() => callPrebid(slot.value), adUnit.refreshTimer * 1000);
          } else {
            refreshTimer.value = activeTabInterval(() => {
              window.googletag.pubads().refresh([slot.value]);
            }, adUnit.refreshTimer * 1000);
          }
        });
      });
      window.addEventListener('scroll', handleScroll);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    return { closeAd, showFooterAd, afterLeave, buttonDivWidth };
  },
});
</script>
<style lang="scss" scoped>
.collapse {
  font-size: 0;
  transform: translateX(calc(-1 * ((100vw - 100%) / 2 - 7px)));
}

.collapse-enter-active,
.collapse-leave-active {
  transition: transform 1s;
}

.collapse-enter {
  transform: translateX(0px);
}

.move-bottom-enter-active,
.move-bottom-leave-active {
  transition: transform 1s;
}
.move-bottom-enter,
.move-bottom-leave-to {
  transform: translateY(100px);
}
</style>
